import { Skeleton } from "@/components/ui/skeleton"

export default function NewsDetailSkeleton() {
  return (
    <div className="px-4 pt-16">
      {/* 프로필 영역 스켈레톤 */}
      <div className="flex py-2.5 px-4 gap-4 flex-start">
        {/* 프로필 이미지 스켈레톤 */}
        <div className="size-10 shrink-0">
          <Skeleton className="w-full h-full rounded-2xl" />
        </div>

        {/* 이름과 날짜 스켈레톤 */}
        <div className="flex flex-col gap-1 justify-center text-start">
          <Skeleton className="w-24 h-4" />
          <Skeleton className="w-20 h-3" />
        </div>
      </div>

      {/* 콘텐츠 영역 스켈레톤 */}
      <div className="p-4 text-start">
        {/* 제목 스켈레톤 */}
        <Skeleton className="mb-3 w-full h-5" />

        {/* 내용 스켈레톤 (여러 줄) */}
        <div className="mb-6 space-y-2">
          <Skeleton className="w-full h-4" />
          <Skeleton className="w-full h-4" />
          <Skeleton className="w-3/4 h-4" />
        </div>

        {/* 썸네일 이미지 스켈레톤 */}
        <div>
          <Skeleton className="w-full h-48 rounded-xl" />
        </div>
      </div>
    </div>
  )
}
